import { gamifyEvent } from "@/lib/api";
import { toast } from "sonner";

const loggedIn = () => !!localStorage.getItem("dharmartha_token");

// Fire a gamification event. Silently no-ops for logged-out visitors.
// Shows a toast for newly earned badges and level-ups. Never throws.
export async function fireGamify(type, ref = null, amount = 1) {
  if (!loggedIn()) return null;
  try {
    const res = await gamifyEvent(type, ref, amount);
    (res.new_badges || []).forEach((b) => {
      toast(`New badge · ${b.en}`, { description: b.desc });
    });
    if (res.leveled_up && res.level) {
      toast(`Level up · ${res.level.en}`, { description: "Your sadhana deepens. Keep going!" });
    }
    return res;
  } catch {
    return null;
  }
}
